import aframe from 'aframe';

if (aframe.INSPECTOR !== undefined) {
  InspectorEvents();
} else {
  window.addEventListener("inspector-loaded", InspectorEvents);  
}

function InspectorEvents() {
  const on = aframe.INSPECTOR.on;

  on("inspectormodechanged", active => {
    if (active) {
      emit(scene, "inspectorenabled");
    } else {
      emit(scene, "inspectordisabled");
    }
  });

  on("selectedentitycomponentchanged", event => {
    emit(event.target, "inspectorcomponentchanged");
  });
}

let scene = undefined;
function emit(entity, msg, data) {
  if (scene === undefined) {
    // inspector-events component isn't active in scene, so dont send events.
    return;
  }
  entity.emit(msg, data);
}

aframe.registerComponent("inspector-events", {
  init() {
    if (scene !== undefined) {
      throw new Error("Can only have one inspector-events component.");
    }
    scene = this.el.sceneEl;
  },
  remove() {
    scene = undefined;
  }
});